import { accountContactListsClient } from '@/api/clients/index';
import { isBoolean } from 'lodash-es';

export default (accountId = null) => {
  if (!accountId) {
    return false;
  }

  return {
    name: 'contact_list',
    label: 'Contact List',
    fetchOptions: async (queryParams = {}) => {
      try {
        const response = await accountContactListsClient.list(accountId, {
          params: {
            ...queryParams,
            page: {
              ...(queryParams.page || {}),
              size: 15,
            },
          },
        });

        return Promise.resolve({
          data: (response?.data || []).map((contactList) => ({
            value: contactList.id,
            label: contactList.name,
          })),
          meta: response?.data?.meta || null,
        });
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getMessage: async (value, cb) => {
      if (isBoolean(value)) {
        cb(value);
      }

      let ids = value;

      if (typeof ids === 'string') {
        ids = ids.split(',');
      }

      if (Array.isArray(ids) === false) {
        ids = [ids];
      }

      try {
        const response = await accountContactListsClient.list(accountId, {
          filter: { id: ids },
        });

        const labels = ids.map((id) => {
          const contactList = response.data.find((item) => item.id === id);

          if (!contactList) {
            return id;
          }

          return contactList.name;
        });

        return Promise.resolve(cb(labels));
      } catch (error) {
        return Promise.resolve(cb(value));
      }
    },
    filters: [
      {
        name: 'contact_list__is',
        label: 'Contact List is',
        input: 'chips',
        value: null,
        message: (value) => `**contact list** is **${value}**`,
      },
      {
        name: 'contact_list__is_not',
        label: 'Contact List is not',
        input: 'chips',
        value: null,
        message: (value) => `**contact list** is not **${value}**`,
      },
      {
        name: 'contact_list__in',
        label: 'Contact List is one of',
        input: 'chips:multiple',
        value: [],
        message: (value) => `**contact list** is one of **${value.join(', ')}**`,
      },
      {
        name: 'contact_list__not_in',
        label: 'Contact List is not one of',
        input: 'chips:multiple',
        value: [],
        message: (value) => `**contact list** is not one of **${value.join(', ')}**`,
      },
    ],
  };
};
